const menu = {
    add: 'menu/add',
    update: 'menu/update',
    remove: 'menu/remove',
    getall: 'menu/getall',
}
export default menu
